import { render, staticRenderFns } from "./bannerLeft.vue?vue&type=template&id=3e544ae8&scoped=true&"
import script from "./bannerLeft.vue?vue&type=script&lang=ts&"
export * from "./bannerLeft.vue?vue&type=script&lang=ts&"
import style0 from "./bannerLeft.vue?vue&type=style&index=0&id=3e544ae8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e544ae8",
  null
  
)

export default component.exports